'use client';

import classnames from 'classnames';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { FC, ReactNode, useEffect, useMemo, useRef } from 'react';

import styles from './ContentHubHero.module.scss';

interface Props {
  href: string;
  title: ReactNode;
}

export const ContentHubHeroNavLink: FC<Props> = ({ href, title }) => {
  const pathname = usePathname();
  const ref = useRef<HTMLLIElement>(null);
  const isActive = useMemo(() => (pathname ?? '/') === href, [pathname]);

  // Horizontally scroll to the element so it's in the view
  useEffect(() => {
    if (isActive && ref.current && typeof ref.current.parentElement?.scroll !== 'undefined') {
      const windowWidth = window.innerWidth;
      const elementOffsetLeft = ref.current.offsetLeft;
      const elementOffsetRight = elementOffsetLeft + ref.current.clientWidth;
      const parentScroll = ref.current.parentElement.scrollLeft;
      if (elementOffsetRight - parentScroll > windowWidth || elementOffsetLeft - parentScroll < 0) {
        ref.current.parentElement?.scroll({ left: ref.current.offsetLeft });
      }
    }
  }, [isActive]);

  return (
    <li className={styles.navItem} ref={ref}>
      <Link href={href} className={classnames(styles.navLink, { [styles.active]: isActive })}>
        {title}
      </Link>
    </li>
  );
};
